import { render } from "./CompletionIndicator.vue?vue&type=template&id=d12d64a6"
import script from "./CompletionIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletionIndicator.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Study/CompletionIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d12d64a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d12d64a6', __exports__)) {
    api.reload('d12d64a6', __exports__)
  }
  
  module.hot.accept("./CompletionIndicator.vue?vue&type=template&id=d12d64a6", () => {
    api.rerender('d12d64a6', render)
  })

}


export default __exports__